module.exports = __webpack_public_path__ + "static/Q3_2025_Investor_Presentation-3815ca40c3bf1ff4a55f1d613608acc0.pdf";